import React from 'react'
import { Box, Typography } from '@mui/material'

interface OnboardInfluencerProps {
  title: string
  children: React.ReactNode
}

const OnboardInfluencer: React.FC<OnboardInfluencerProps> = ({
  children,
  title,
}) => {
  return (
    <Box width="100%" maxWidth={700}>
      <Typography variant="body1" mb={2}>
        {title}
      </Typography>
      <Box>{children}</Box>
    </Box>
  )
}

export default OnboardInfluencer
